import { render, staticRenderFns } from "./HongKongWatchlist.vue?vue&type=template&id=e2fb7e80&scoped=true"
import script from "./HongKongWatchlist.vue?vue&type=script&lang=js"
export * from "./HongKongWatchlist.vue?vue&type=script&lang=js"
import style0 from "./HongKongWatchlist.vue?vue&type=style&index=0&id=e2fb7e80&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e2fb7e80",
  null
  
)

export default component.exports